"use strict";

exports.__esModule = true;
exports.default = void 0;
var borderRadius = {
  'border-radius': '4px'
};
var typography = {
  gothamRounded: 'Gotham Rounded, Arial Rounded MT Bold, Helvetica, sans-serif',
  helvetica: 'Helvetica Neue, Helvetica, Arial, sans-serif'
};
var fillAbsoluteSpace = "\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n";

var fullBleed = function fullBleed(position) {
  return "\n  position: " + (position || 'fixed') + ";\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n";
};

var fade = function fade(show, duration) {
  return "\n  transition: opacity " + (duration || 0.35) + "s ease-in-out;\n  opacity: " + (show ? '1' : '0') + ";\n";
};

var fadeUp = function fadeUp(show, duration, top) {
  return "\n  position: relative;\n  transition: all " + (duration || 0.35) + "s ease-out;\n  top: " + (show ? '0' : top || '10px') + ";\n  opacity: " + (show ? '1' : '0') + ";\n";
};

var _default = {
  borderRadius: borderRadius,
  typography: typography,
  fillAbsoluteSpace: fillAbsoluteSpace,
  fullBleed: fullBleed,
  fade: fade,
  fadeUp: fadeUp
};
exports.default = _default;